





























































import Vue from "vue";
import Component from "vue-class-component";
import Divider from "../../components/common/Divider.vue";
import { SocialMedia as SMInterface } from "../../services/social-media/entities/social-media.interface";
import constants from "../../config/constants";

@Component({
  components: {
    Divider
  }
})
export default class PreFooter extends Vue {
  private created(): void {
    this.$store.dispatch("socialMedia/getSocialMedia");
  }

  private get githubURL(): string {
    const socialMedia = this.$store.getters["socialMedia/getSocialMedia"];

    const result = socialMedia.filter(
      (socialM: SMInterface) => socialM.socialMediaIcon == "mdi-github"
    );

    if (result[0] !== undefined) {
      if (result[0].socialMediaStatus !== constants.STATUS.INACTIVE) {
        return result[0].socialMediaURL;
      } else {
        return `#none#`;
      }
    } else {
      return `#none#`;
    }
  }
}
